import React from "react";

type RouterContextType = any;

const RouterContext = React.createContext<RouterContextType | null>(null);

/**
 * Hook for getting the app router.
 *
 * Not currently used but should be usable in functional components to parallel
 * withRouter HOC.
 * @returns Router instance or null if not found
 */
export const useRouter = () => {
	return React.useContext(RouterContext);
};

export default RouterContext;
